export default __webpack_public_path__ + "static/media/homesl1.08ef45ee.png";